import { useStrictInstance } from '@funtech-int/rival-react';

import { graphqlClientRef } from '@/shared/lib/graphqlClient';

export function useGraphqlClient() {
    return useStrictInstance(graphqlClientRef);
}
